<template>
  <img v-if='selected' class="radio-icon" src="@/assets/img/radio-marked.svg" alt="selected">
  <img v-else class="radio-icon" src="@/assets/img/radio-unmarked.svg" alt="selected">
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props:{
        selected: {type: Boolean, required: true}
    }
});
</script>

<style scoped>
    .radio-icon{
        height: 24px;
        width: 24px;
        margin: 0;
}
</style>
